import { z } from "zod";
export const widgetReferenceSchema = z.object({
  widgetId: z.string().uuid(),
  title: z.string().min(1).max(120),
});
export type WidgetReference = z.infer<typeof widgetReferenceSchema>;
export function parseWidgetReferences(value: unknown): WidgetReference[] {
  const parsed = z.array(widgetReferenceSchema).max(20).safeParse(value);
  return parsed.success ? parsed.data : [];
}
export function parseWidgetBody(text?: string): WidgetReference[] {
  try {
    return parseWidgetReferences(JSON.parse(text ?? "").content?.widgets);
  } catch {
    return [];
  }
}
export const widgetReadSchema = z.object({
  widgetId: z.string().uuid(),
  title: z.string().max(120),
  sizeBytes: z
    .number()
    .int()
    .positive()
    .max(25 * 1024 * 1024),
  sha256: z.string().regex(/^[a-f0-9]{64}$/),
  html: z.string().max(25 * 1024 * 1024),
});
const packageSchema = z.object({
  version: z.literal(1),
  bundle: z.string().min(1).max(3_000_000),
  digest: z.string().regex(/^[a-f0-9]{64}$/),
});
export function readWidgetPackage(html: string) {
  const prefix = "<!--lawworks-widget:v1:";
  const start = html.indexOf(prefix);
  const end = html.indexOf("-->", start);
  if (start < 0 || end < 0)
    throw new Error("This widget requires a page reload.");
  const encoded = html.slice(start + prefix.length, end);
  if (encoded.length > 7_000_000)
    throw new Error("The widget package is too large.");
  const bytes = Uint8Array.from(atob(encoded), (c) => c.charCodeAt(0));
  return packageSchema.parse(
    JSON.parse(new TextDecoder("utf-8", { fatal: true }).decode(bytes)),
  );
}
export const widgetToolResultSchema = z.object({
  isError: z.boolean().optional(),
  content: z.array(z.object({ type: z.literal("text"), text: z.string() })),
  structuredContent: z.record(z.unknown()).optional(),
  _meta: z.record(z.unknown()).optional(),
});
